import React from "react";
import Header from "../components/Header";
import { link } from "react-router-dom";
import Footer from "../components/Footer";

function PrivacyNotice() {
  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/trademark", label: "Trademark Attribution" },
    { to: "/get-in-touch", label: "Get in touch" },
  ];

  return (
    <>
      <Header links={navLinks} />

      <main>
        <section class="bg-white dark:bg-gray-900">
          <div class="max-w-screen-xl px-4 py-10 mx-auto lg:py-24 lg:px-6 text-center">
            <div class="max-w-screen-md mx-auto mb-8 text-left lg:mb-12">
              <h2 class="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">Data Privacy Policy</h2>
              <div>
                <p>Welcome to DataPulse! We are committed to protecting your privacy and handling your information in an open and transparent manner. This Privacy Policy explains how we collect, use, and safeguard your information when you use our website (<a href="https://www.mydatapulse.co.uk">www.mydatapulse.co.uk</a>) and when you communicate with us via WhatsApp Messenger.</p>

                <div class="section">
                  <br />
                  <h2><strong>1. Information We Collect</strong></h2>
                  <ul>
                    <li>Contact Information: such as your name, email address, phone number, and company details.</li>
                    <li>Communications: any messages you send us via WhatsApp, email, or our website.</li>
                    <li>Technical Data: including IP address, browser type, and usage patterns when you interact with our website.</li>
                    <li>Business Information: relevant business details shared for providing our services.</li>
                  </ul>
                </div>

                <div class="section">
                  <br />
                  <h2><strong>2. How We Use Your Information</strong></h2>
                  <ul>
                    <li>Provide, improve, and personalize our services.</li>
                    <li>Respond to your inquiries and communicate with you via WhatsApp or other channels.</li>
                    <li>Send service updates, promotions, or informational content with your consent.</li>
                    <li>Maintain security and monitor usage trends on our website.</li>
                  </ul>
                </div>

                <div class="section">
                  <br />
                  <h2><strong>3. Communication via WhatsApp Messenger</strong></h2>
                  <p>By initiating communication with DataPulse AI on WhatsApp, you consent to us:</p>
                  <ul>
                    <li>Storing and processing your WhatsApp messages.</li>
                    <li>Using your WhatsApp-provided phone number to respond to inquiries, provide updates, or deliver services.</li>
                  </ul>
                  <p>We adhere to WhatsApp Business Policy guidelines, ensuring that:</p>
                  <ul>
                    <li>Your information is used solely for purposes related to the services you request.</li>
                    <li>We do not share your WhatsApp data with third parties without your explicit consent.</li>
                    <li>You can opt out of receiving further WhatsApp communications from us at any time by informing us in the chat. Once you opt out, we will no longer send you messages via WhatsApp unless you initiate contact again.</li>
                  </ul>
                  <p>Please note that when you communicate with us via WhatsApp, your information is also subject to WhatsApp's own privacy practices. For more details, please review <a href="https://www.whatsapp.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer">WhatsApp's Privacy Policy</a>.</p>
                </div>

                <div class="section">
                  <br />
                  <h2><strong>4. Data Sharing and Disclosure</strong></h2>
                  <p>We do not sell, rent, or trade your personal data. We may share your data with trusted third-party service providers under strict confidentiality agreements. We may also disclose information if required by law or to protect our rights.</p>
                </div>

                <div class="section">
                  <br />
                  <h2><strong>5. Data Security</strong></h2>
                  <ul>
                    <li>We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, misuse, or loss.</li>
                  </ul>
                </div>

                <div class="section">
                  <br />
                  <h2><strong>6. Data Retention</strong></h2>
                  <p>We retain your personal information only for as long as necessary to fulfill the purposes we collected it for, including satisfying any legal, accounting, or reporting requirements.</p>
                </div>

                <div class="section">
                  <br />
                  <h2><strong>7. Your Rights</strong></h2>
                  <ul>
                    <li>Access the personal data we hold about you.</li>
                    <li>Request correction or deletion of your information.</li>
                    <li>Withdraw consent for communication at any time.</li>
                    <li>Lodge a complaint with the UK Information Commissioner's Office (ICO) if you believe your rights have been infringed.</li>
                  </ul>
                </div>

                <div class="section">
                  <br />
                  <h2><strong>8. Changes to This Privacy Policy</strong></h2>
                  <p>We may update this Privacy Policy from time to time. When we do, we will revise the "Last Updated" date. We encourage you to review this Policy regularly.</p>
                  <br />
                  <p>Last Updated: 26/04/2025</p>
                </div>

                <div class="section">
                  <br />
                  <h2><strong>9. Contact Us</strong></h2>
                  <p class="contact">📩 Email: <a href="mailto:info@mydatapulse.co.uk">info@mydatapulse.co.uk</a></p>
                  <p class="contact">🌍 Website: <a href="https://www.mydatapulse.co.uk">www.mydatapulse.co.uk</a></p>
                </div>

              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default PrivacyNotice;

